<script>
import * as BABYLON from "@babylonjs/core"
//引入@babylonjs/loaders模块，用于加载gltf文件
import "@babylonjs/loaders";
import router from "@/router"
import * as GUI from '@babylonjs/gui'
import dParams from '@/views/front/scds/subsystems/components/data/params.json'
import system_model from '@/views/front/scds/subsystems/components/data/system_model.json'

let baseUrl_Floor = "https://cabrenergy-v2-1255710621.cos.ap-beijing.myqcloud.com/bim/82/Floors/"
let baseUrl_SYS = "https://cabrenergy-v2-1255710621.cos.ap-beijing.myqcloud.com/bim/82/glb-0616/"
let framework_key = 'ALL'

let _scene = null
let _engine = null
let _camera = null
let _camera_bak = null
// let _framework_meshes = null
let _hl = null
let _redBall_meshes = []
let merged_meshes = []
let parent = {}
//弹窗静态数据随机生成
//控制电梯动画的递归函数
let isDT = false;
let containers = {}
// 爆炸效果对象，注：作为响应式变量会引起很明显的卡顿
let newExplosion = null
let _xfbj_animation = null
let _xfbj_mesh = []
//隐蔽工程管道的节点的名称
let _ybgc_pipeNodeName = ['node256', 'node257', 'node255', 'node261', 'node253',
  'node254', 'node258', 'node252', 'node232',
  'node231', 'node238', 'node227', 'node229', 'node228', 'node239', 'node233',
  'node235', 'node240', 'node234', 'node230', 'node237', 'node241', 'node236',
  '地下楼梯间加压送风_1', '地上楼梯间加压送风_1', 'node263', 'node266', 'node260',
  'node264', 'node259', 'node262', 'node265'
]
//GUI,hjjc
let advancedTexture = null;
let guiContainer = []; //gui组件的对象，进行隐藏
let HjjcT = []; //保存环境监测模型中生成的温度
/*************************************************************************************/
/*                                  BABYLONJS                                        */
/*************************************************************************************/
export default {
  name: "Model",
  props: {
    systemKey: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      frameWorkHeight: 0,
      // newExplosion: null,
      oldAlpha: null,
      isShowTC: false, //是否展示模型旁边的弹窗
      dPar: [{
        "param": "故障报警",
        "param_key": "F",
        "unit": "正常||故障",
        "range": [0, 1]
      },  //模型弹窗的静态数据生成
      {
        "param": "运行状态",
        "param_key": "S",
        "unit": "停机||运行",
        "range": [0, 1]
      }],
      cardTitle: "设备名称",
      cardId: "弹窗设备Id",
      cardMeshId:'',
      system_model: system_model,
      currentKey:'',
      currentSystem: '',
      currentFloor: '',
      currentFloorSystem: '',
      currentSphere: '',
      lightData: [
        {
          "name": 'DL1',
          "status": false
        },
        {
          "name": 'DL2',
          "status": false
        },
        {
          "name": 'SL',
          "status": false
        }
      ],
      yjLightData: [
        {
          "name": '应急照明灯',
          "status": false
        },
        {
          "name": '疏散指示灯',
          "status": false
        },
      ],
      system_type: null, //全局判断加载模型类型的对象
      isRotate: false,
      isExplode: false,
      isWarning: false,
      isLoadingFramework:false,
      device_status_dict:{},//设备运行状态
    };
  },
  watch: {
    '$route.path': {
      handler(toPath, fromPath) {
        console.log('路由变化了')
        this.toPath = toPath;
        if (_redBall_meshes) {
          _scene && this.clearBall();
        }
        if (_scene) {
          _scene.dispose();
          _scene = null;
        }
        containers = {}
        merged_meshes = []
        parent = {}
        this.device_status_dict = {}
      },
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
  methods: {
    // 加载子模型 通用函数
    // type 四种类型：框架，子系统，楼层，分层子系统  'framework','floor','system','floor_system'
    loadModel(key, type, ext = "glb") {
      // 建筑透明材质
      let transparentMat = new BABYLON.StandardMaterial("transparentMat", _scene);
      transparentMat.alpha = 0.15;
      transparentMat.emissiveColor = new BABYLON.Color3(0.149, 0.357, 0.588);
      transparentMat.wireframe = false;
      return new Promise((resolve, reject) => {
        if (key) {
          this.system_type = type;

          containers[this.currentSphere] && containers[this.currentSphere].removeAllFromScene()

          if (type === 'framework') {
            this.clearBall()
            // 关闭右侧大样图侧边栏
            this.$emit('closeSideBar')
            this.$emit('changeSysButtonDisabled', true)
            containers[this.currentSystem] && containers[this.currentSystem].removeAllFromScene()
            containers[this.currentFloor] && containers[this.currentFloor].removeAllFromScene()
            containers[this.currentFloorSystem] && containers[this.currentFloorSystem].removeAllFromScene()
          }

          if (type === 'system') {
            this.cardMeshId = ''
            this.clearBall()
            // 关闭右侧大样图侧边栏
            this.$emit('closeSideBar')
            this.$emit('changeSysButtonDisabled', true)
            containers[framework_key] && containers[framework_key].addAllToScene()
            containers[this.currentSystem] && containers[this.currentSystem].removeAllFromScene()
            containers[this.currentFloor] && containers[this.currentFloor].removeAllFromScene()
            containers[this.currentFloorSystem] && containers[this.currentFloorSystem].removeAllFromScene()
          }

          if (type === 'floor') {
            // 关闭右侧大样图侧边栏
            this.clearBall()
            this.$emit('closeSideBar')
            this.$emit('changeFloorButtonDisabled', true)
            this.$emit('changeDeviceButtonDisabled', true)
            containers[framework_key] && containers[framework_key].removeAllFromScene()
            containers[this.currentSystem] && containers[this.currentSystem].removeAllFromScene()
            containers[this.currentFloor] && containers[this.currentFloor].removeAllFromScene()
            containers[this.currentFloorSystem] && containers[this.currentFloorSystem].removeAllFromScene()
          }

          if (type === 'floor_system') {
            this.cardMeshId = ''
            this.$emit('changeFloorButtonDisabled', true)
            this.$emit('changeDeviceButtonDisabled', true)
            containers[framework_key] && containers[framework_key].removeAllFromScene()
            containers[this.currentSystem] && containers[this.currentSystem].removeAllFromScene()
            containers[this.currentFloorSystem] && containers[this.currentFloorSystem].removeAllFromScene()
          }

          //消防系统显示红球
          if (key.endsWith('xfxt')) {
            this.addRedBallInFrameWork();
          }
          //隐蔽工程管道的颜色
          let ybgc_pipeMaterial = new BABYLON.StandardMaterial("ybgc_pipeMaterial", _scene);
          ybgc_pipeMaterial.emissiveColor = new BABYLON.Color3(102 / 255, 217 / 255, 255 / 255);
          ybgc_pipeMaterial.alpha = 0.4;

          let green_meterial_sphere = new BABYLON.StandardMaterial("green_meterial_sphere", _scene);
          green_meterial_sphere.emissiveColor = new BABYLON.Color3(0, 1, 0);

          let red_meterial_sphere = new BABYLON.StandardMaterial("red_meterial_sphere", _scene);
          red_meterial_sphere.emissiveColor = new BABYLON.Color3(1, 0, 0);
          red_meterial_sphere.diffuseColor = new BABYLON.Color3(1, 0, 0);

          let yellow_meterial_sphere = new BABYLON.StandardMaterial("yellow_meterial_sphere", _scene);
          yellow_meterial_sphere.emissiveColor = new BABYLON.Color3(1, 128 / 255, 0);
          yellow_meterial_sphere.diffuseColor = new BABYLON.Color3(1,128/255,0);

          let gray_meterial_sphere = new BABYLON.StandardMaterial("gray_meterial_sphere", _scene);
          gray_meterial_sphere.emissiveColor = new BABYLON.Color3(0.5, 0.5, 0.5);
          gray_meterial_sphere.diffuseColor = new BABYLON.Color3(0.5, 0.5, 0.5);

          // 运行 故障 警告 停机
          let colors = [green_meterial_sphere, yellow_meterial_sphere, gray_meterial_sphere, red_meterial_sphere]
          /** 加载新的子系统。
           * 如果子系统的模型，已经下载过，并已经保存到 containers[] 数组中了，就直接使用本地保存的版本。 */
          if (containers[key] && containers[key].meshes?.length > 0) {
            console.log(`--- container ${key}  存在。`, containers[key], containers[key].meshes.length)
            containers[key].addAllToScene()
            containers[`${key}_sphere`] && containers[`${key}_sphere`].addAllToScene()
            this.$emit('changeSysButtonDisabled', false)
            if (key == 'F28' && this.currentSystem == 'xfxt') {
              this.addRedBallInFloor(containers[key])
            }
            resolve(containers[key]);
          } else {
            console.log(`首次加载${key}--------------------`);
            let file_name = type === 'system' ? `scds-${key}.${ext}` : `${key}.${ext}`
            let baseUrl = type === 'system' ? baseUrl_SYS : baseUrl_Floor

            BABYLON.SceneLoader.LoadAssetContainerAsync(baseUrl, file_name, _scene)
              .then(container => {
                containers[key] = container
                console.log(`--- 加载子系统  ${key} 成功 。 mesh 数 = ${container.meshes.length}`, container)
                // 首次加载楼层
                if (type === 'floor') {
                  container.meshes.forEach(m => {
                    m.isPickable = false
                    m.material = transparentMat
                  })
                  if (key == 'F28' && this.currentSystem == 'xfxt') {
                    this.addRedBallInFloor(container)
                  }
                }

                // 首次加载子系统
                if ((type === 'system' || type === 'floor_system') && !(key === 'ggzm' || key === 'yjzm')) {
                  let sphere_container = new BABYLON.AssetContainer(_scene);
                  let device_status = {}
                  container.meshes.forEach(mesh => {
                    /** chenxi 20240620
                     * 建模师常常在建模软件中，使用一个组件(Component)，创建多个实例(Instance) 的方法，来批量创建多个相同的物体，例如：冷却塔，发电机，树木，等等。
                     * 因此导出的模型中，会出现多个类型为 InstancedMesh 的 Mesh. 程序员可以用 mesh.getClassName() 函数，来获取 Mesh 的类型。
                     *
                     * InstancedMesh 不能被单独修改属性。程序员必须通过 mesh.sourceMesh, 找到并修改 Source Mesh 的属性,
                     * 所有与它关联的 Instanced Mesh 就会被一同修改。
                     *
                     * 但是，我们在智能建筑系统中，必须能够修改每一个 Mesh. 例如，某一个冷却设备有报警时，我们希望把它标记为红色。
                     * 解决办法时，使用 mesh.sourceMesh.clone() 函数，复制一份新的 Mesh.
                     *
                     * 请注意，当 Instanced Mesh 数量很多时，clone() 需要比较长的时间（几秒钟），用户会在页面等待时间较长，体验较差。
                     * 建议在模型第一次加载时，就完成这些复制。
                     *
                     * 另外，克隆后的普通 Mesh 的渲染速度，比 InstancedMesh 慢。这也是 InstancedMesh 的优点。
                     * */

                    mesh.isPickable = true
                    if (mesh.name.includes('SCDS') && mesh.name.includes('_primitive0')) {
                      this.addSphere(mesh, colors, type, sphere_container, device_status)
                    }
                    /** 注册鼠标事件。当鼠标滑过 Mesh 或者点击 Mesh 时，触发事件。 */
                    mesh.actionManager = new BABYLON.ActionManager(_scene)
                    // // 注册鼠标点击 Mesh 的事件响应。
                    mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(
                      BABYLON.ActionManager.OnPickTrigger,
                      (evt) => {
                        console.log('----- 用户点击了 = ', evt.source?.name, evt)
                        // this.$emit('showSidebar', false);
                        if (!this.$route.path.includes("project-detail")) {
                          if (this.currentKey === 'hjjc'){
                            this.$emit('showSidebar', { isShow: true, evt: evt, HjjcT: HjjcT});
                          }else {
                            this.$emit('showSidebar', { isShow: true, evt: evt });
                          }
                        } else {
                          this.$emit('showSidebar', { isShow: false, evt: null });
                        }
                      },
                      null)
                    )

                    // 注册鼠标滑动到 Mesh 上的事件响应函数。
                    mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(
                      BABYLON.ActionManager.OnPointerOverTrigger,
                      (evt) => {
                        // console.log('----- 用户鼠标划过 = ',  evt.source?.name)
                        let name = evt.source?.name;
                        if (name.startsWith("SCDS")) {
                          const box = document.getElementById('TC_box')
                          if (box) {
                            let code = "";
                            let index = name.indexOf('_primitive')
                            if (index !== -1) {
                              code = name.slice(0, index)
                            } else {
                              code = name
                            }
                            // console.log('code',code);
                            this.cardTitle = '暂无名称'
                            //弹窗随机数据生成
                            if (name.includes('KTTF_FCU')) {
                              this.cardTitle = '风机盘管';
                            }
                            this.system_model.some((item) => {
                              if (code === item.equip_code) {
                                this.cardTitle = item.equip_name;
                                return true
                              }
                            })
                            this.cardId = code;
                            // this.cardMeshId = evt.source?.id
                            this.cardMeshId = code;
                            //暂时修改风机盘管温度的参数
                            let str = name.split('_')[4].match(/[a-zA-Z]+/g)
                            this.dPar = dParams[name.split('_')[4].match(/[a-zA-Z]+/g)];
                            // console.log("dpar",this.dPar);
                            if (str[0] === 'FCU') {
                              //暂时修改风机盘管温度的参数
                              this.dPar[5].range = [(Math.random() * 5 + 20).toFixed(1)];
                              // console.log("进入修改FCU",this.dPar[5].range);
                            }
                            // console.log("dpar", this.dPar);
                            // 调整偏移量
                            let cardX = evt.pointerX;
                            let cardY = evt.pointerY;
                            box.style.display = 'block';
                            box.style.top = (cardY - 180 - 20) + 'px'
                            box.style.left = (cardX + 40) + 'px'
                            // box.style.top = (cardY - 180 - 10) + 'px'
                            // box.style.left = (cardX + 40 + 5) + 'px'

                          } else {
                            document.getElementById('TC_box').style.display = 'none';
                            this.$emit('subSystemShowSidebar', { isShow: false, evt: null });
                          }
                        } else if (name.includes("室内环境传感器") || name.includes("CO传感器")) {
                          const box = document.getElementById('TC_box');
                          if (box) {
                            this.cardTitle = name;
                            this.cardId = null;
                            this.dPar = dParams[this.cardTitle];
                            console.log('name.split[\'_\'].length > 1',name,name.split('_'));
                            if (name.split('_').length > 1) {
                              this.cardTitle = name.split('_')[0];
                              this.dPar =dParams[this.cardTitle];
                              for (let key in HjjcT){
                                if(key === name ){
                                  this.dPar[0].range = [HjjcT[key]];
                                }
                              }
                            }
                            // 调整偏移量
                            let cardX = evt.pointerX;
                            let cardY = evt.pointerY;
                            box.style.display = 'block';
                            // box.style.top = (cardY - 180 - 10) + 'px'
                            // box.style.left = (cardX + 40 + 5) + 'px'
                            box.style.top = (cardY - 180 - 20) + 'px'
                            box.style.left = (cardX + 40) + 'px'
                          } else {
                            document.getElementById('TC_box').style.display = 'none';
                            this.$emit('subSystemShowSidebar', { isShow: false, evt: null });
                          }
                        } else {
                          document.getElementById('TC_box').style.display = 'none';
                          this.$emit('subSystemShowSidebar', { isShow: false, evt: null });
                        }
                        this.$emit('subSystemShowSidebar', { isShow: false, evt: null });
                      },
                      null)
                    )
                    //注册鼠标从mesh上移开的函数
                    mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(
                      BABYLON.ActionManager.OnPointerOutTrigger,
                      (evt) => {
                        // console.log("----鼠标从mesh移开 =", evt.source?.name);
                        document.getElementById('TC_box').style.display = 'none';
                      }
                    ))

                    //修改隐蔽工程管道的颜色
                    if (key.endsWith('ybgc') && _ybgc_pipeNodeName.includes(mesh.name)) {
                      mesh.material = ybgc_pipeMaterial;
                    }
                  })
                  containers[`${key}_sphere`] = sphere_container
                  this.device_status_dict[key] = device_status
                  console.log('this.device_status_dict', this.device_status_dict);
                }

                  if(key.endsWith('hjjc')){
                    this.showHJJCDetail(containers[key].meshes);
                  }
                  /** 把子系统模型显示在页面上。 */
                  container.addAllToScene()
                  resolve(container);

                this.$emit('changeSysButtonDisabled', false)
              }).catch(error => {
                reject(error)
                this.$emit('changeSysButtonDisabled', false)
                this.$emit('changeFloorButtonDisabled', false)
              })
          }

          /** 把当前子系统的 key 保存下来。下一次，用户切换子系统时，需要先把当前子系统从页面上去除。**/
          if (type === 'floor') {
            this.currentFloor = key
          } else if (type === 'system') {
            this.currentSystem = key
          } else if (type === 'floor_system') {
            this.currentFloorSystem = key
          }

          if (type !== 'framework' && type !== 'floor') {
            this.currentSphere = key + "_sphere"
            this.currentKey = key
          }
        }
      })
    },
    // 复制一个mesh
    cloneMesh(mesh, material = null) {
      let newMesh = mesh.clone()
      newMesh.position = mesh.position.clone();
      newMesh.material = material
      if (mesh.rotationQuaternion) {
        newMesh.rotationQuaternion = mesh.rotationQuaternion.clone();
      }
      newMesh.scaling = mesh.scaling.clone()
      return newMesh
    },
    initScene() {
      //创建一个canvas，并设置class为“canvas”
      const canvas = document.getElementById("babylonCanvas");

      //  创建 babylonjs 3D 引擎
      const engine = new BABYLON.Engine(canvas);

      engine.displayLoadingUI();

      //  创建一个场景
      const scene = new BABYLON.Scene(engine);

      scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);

      //  创建一个摄像头
      const camera = new BABYLON.ArcRotateCamera(
        "camera",
        -Math.PI / 2,
        Math.PI / 2,
        300,
        new BABYLON.Vector3(0, 0, 0)
      );
      // ArcRotateCamera的可选参数，如果设置为true，则鼠标滚轮将放大或缩小以当前鼠标位置为中心，而不是固定的 camera.target 位置。这样可以轻松探索大场景的所有角落。
      camera.zoomToMouseLocation = false
      // ArcRotateCamera的可选参数，如果设置为非零值，则缩放量将设置为相机半径的百分比。当靠近目标对象时，变焦速度会减慢，这很好，因为这意味着您在近距离探索对象时可以更精确地放置相机。
      camera.wheelDeltaPercentage = 0.5

      // camera.setPosition(new BABYLON.Vector3(0, 55, -50));
      // This targets the camera to scene origin
      // camera.setTarget(BABYLON.Vector3.Zero());

      camera._panningMouseButton = 2;
      // 定义输入的平移灵敏度，值越小灵敏度越高
      camera.panningSensibility = 40;
      /**
       * Babylon.js 中, camera.buttons 是一个属性,用于定义相机的按钮交互行为。
       具体来说:
       1. camera.buttons 是一个对象,包含了相机支持的不同按钮的设置。
       2. 默认情况下, camera.buttons 包含以下属性:
       ○ camera.buttons.left: 定义左键的交互行为
       ○ camera.buttons.right: 定义右键的交互行为
       ○ camera.buttons.middle: 定义中键的交互行为
       3. 对于每个按钮,你可以设置以下值:
       ○ 0: 禁用此按钮的交互
       ○ 1: 平移相机
       ○ 2: 旋转相机
       ○ 4: 缩放相机
       例如, camera.buttons.left = 2 表示左键用于旋转相机。
       通过设置 camera.buttons 属性,你可以自定义相机的交互行为,满足不同的需求。这在构建 3D 应用程序时非常有用。
       */
      camera.buttons = [2, 1, 0]

      // Enable mouse wheel inputs.
      // camera.inputs.addMouseWheel();
      camera.wheelPrecision = 150;

      // 限制摄像头的Y轴旋转范围上限
      camera.upperBetaLimit = Math.PI / 2;
      camera.allowUpsideDown = true;

      // 限制摄像头的距离范围
      camera.lowerRadiusLimit = 20;
      camera.upperRadiusLimit = 600;

      // This attaches the camera to the canvas
      camera.attachControl(canvas, true);

      //将模型放大
      camera.wheelDeltaPercentage = 0.02;

      // 创建一个照明灯
      const light = new BABYLON.HemisphericLight(
        "light",
        new BABYLON.Vector3(0, Math.PI / 2.2, 0),
        scene
      );

      // 灯光亮度
      light.intensity = 0.6;

      let hl = new BABYLON.HighlightLayer("hl", scene);

      scene.clearCachedVertexData();

      engine.hideLoadingUI();

      // 不断循环渲染
      engine.runRenderLoop(() => {
        scene.render();
      });

      // 当窗口大小改变时，重新渲染
      // window.addEventListener("resize", () => {
      //   engine.resize();
      // });

      _scene = scene;
      _engine = engine;
      _hl = hl;
      _camera = camera;
      _camera_bak = camera

    },
    // 加载框架模型
    async loadFramework() {
      if (_camera) {
        _camera.zoomToMouseLocation = false
      }
      // 建筑透明材质
      let transparentMat = new BABYLON.StandardMaterial("transparentMat", _scene);
      transparentMat.alpha = 0.15;
      transparentMat.emissiveColor = new BABYLON.Color3(0.149, 0.357, 0.588);
      transparentMat.wireframe = false;
      // 加载框架模型
      await this.loadModel(framework_key, 'framework').then(container => {
        container.meshes.forEach(mesh => {
          if (mesh.parent) {
            if (mesh.id.includes('XFXTBJ')) {
              parent[mesh.id] = [mesh,]
            } else if (parent[mesh.parent.id]) {
              parent[mesh.parent.id].push(mesh)
            } else {
              parent[mesh.parent.id] = [mesh,]
            }
          }
          if (!mesh.name.includes("DEC")) {
            mesh.material = transparentMat;
          }
        })
        // console.log('======parent', parent);
        //先去除掉消防报警地板的模型合并
        for (let key in parent) {
          let merged_mesh
          try {
            merged_mesh = BABYLON.Mesh.MergeMeshes(parent[key], true, true)
          } catch (error) {
            console.log(`MergeMeshes合并${key}楼层出错了`, error);
          }
          merged_mesh && merged_meshes.push(merged_mesh)
        }
        // console.log('===========merged_meshes', merged_meshes);
        container.meshes = merged_meshes
        container.meshes.forEach(mesh => {
          mesh.isPickable = false
        })
        //渲染完成时
        _scene.executeWhenReady(() => {
          newExplosion = new BABYLON.MeshExploder(merged_meshes);
        });
      })
    },
    // 加载子系统
    async loadSubsystemMeshs(key) {
      if (_camera) {
        _camera.zoomToMouseLocation = false
      }
      if (_camera) {
        _camera.radius = 300;
        _camera.alpha = -Math.PI / 2;
        _camera.beta = Math.PI / 2;
      }
      isDT = false;
      if (key && key !== "all") {
        if(!containers[framework_key]){
          await this.loadFramework()
        }
        this.loadModel(key, 'system').then(container => {
          if (key === 'hjjc'){
            if (guiContainer){
              guiContainer.forEach((item) => {
                item.isVisible = true;
              })
            }
          }else {
            if (guiContainer){
              guiContainer.forEach((item) => {
                item.isVisible = false;
              })
            }
          }
          // 模型加载完毕后再打开二级菜单，避免卡死
          this.$emit('showSecondNav')
          _hl.addMesh(containers[key].meshes[0], new BABYLON.Color3(0.6, 0.2, 0.2));
          if (key.endsWith("dtxt")) {
            isDT = true;
            this.DTXTAnimation();
          }
        })
      }
    },
    // 加载楼层
    loadFloorMeshs(floor, load_system = false, id = '') {
      if (_camera) {
        _camera.zoomToMouseLocation = true
      }
      if (guiContainer){
        guiContainer.forEach((item) => {
          item.isVisible = false;
        })
      }
      let floor_key = floor === 'F18/5' ? 'F18-5' : floor
      this.loadModel(floor_key, 'floor').then(container => {
        let white_meterial = new BABYLON.StandardMaterial("white_meterial", _scene);
        white_meterial.emissiveColor = new BABYLON.Color3(1, 1, 1);
        // 加载分层子系统
        let floor_syetem_key = `${floor_key}_${this.currentSystem.toUpperCase()}`
        this.loadModel(floor_syetem_key, 'floor_system').then(container => {
          this.$emit('changeFloorButtonDisabled', false)
          this.$emit('changeDeviceButtonDisabled', false)
          container.meshes.forEach((mesh) => {
            if (load_system && mesh.id.includes(id + '_')) {
              mesh.material = white_meterial
              // 创建闪烁动画
              let flickerAnimation = this.createFlickerAnimation()
              // 将动画添加到网格
              mesh.animations.push(flickerAnimation);
              // 开始播放动画
              _scene.beginAnimation(mesh, 0, 60, false);
              // 结束闪烁后恢复原有材质
              setTimeout(() => {
                mesh.material = null
              }, 2000)
            }
          })

        }).catch(err => {
          this.$emit('changeFloorButtonDisabled', false)
          this.$emit('changeDeviceButtonDisabled', false)
          console.log(`加载分层子系统${floor_syetem_key}失败：`, err);
        })

        let big_floor = ['B1', 'B2', 'B3', 'F1', 'F2', 'F3', 'F4', 'F5']
        if (big_floor.includes(floor)) {
          _camera.radius = 168;
        } else {
          _camera.radius = 76;
        }
        _camera.alpha = -Math.PI / 1.65;
        _camera.beta = Math.PI / 3.5;
      })
    },
    // 从mesh的id获取楼层编码
    getFloorStr(id) {
      // 规则F3/5 -> F3
      let split_arr = id.split('_')
      let floor_str = null
      if (split_arr[2]) {
        if (split_arr[2] === 'F18' && split_arr[3] === '5') {
          floor_str = split_arr[2] + '/' + split_arr[3]
        } else if (split_arr[2] === 'F3/5') {
          floor_str = 'F3'
        } else {
          floor_str = split_arr[2]
        }
      }
      return floor_str
    },
    // 添加闪烁效果
    createFlickerAnimation() {
      let flickerAnimation = new BABYLON.Animation(
        "flickerAnimation",
        "material.alpha",
        30,
        BABYLON.Animation.ANIMATIONTYPE_FLOAT,
        BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
      );

      // 设置关键帧
      let keys = [];
      keys.push({ frame: 0, value: 1 });   // 完全不透明
      keys.push({ frame: 10, value: 0.1 }); // 略微透明
      keys.push({ frame: 20, value: 1 });  // 完全不透明
      keys.push({ frame: 30, value: 0.1 }); // 略微透明
      keys.push({ frame: 40, value: 1 });  // 完全不透明
      keys.push({ frame: 50, value: 0.1 }); // 略微透明
      keys.push({ frame: 60, value: 1 });  // 完全不透明
      flickerAnimation.setKeys(keys);
      return flickerAnimation
    },
    // 添加小球
    addSphere(mesh, colors, type, container, device_status) {
      if (!this.$props.systemKey.endsWith("ggzm") && !this.$props.systemKey.endsWith("dtxt") && mesh.id.startsWith('SCDS')) {
        // const sphere1 = BABYLON.MeshBuilder.CreateSphere("sphere",{segments:4, diameter:0.5}, _scene);
        /**
         * CreateSphere的参数segments，默认为32，这里设置为4，小球放大后会没有那么圆，但是会流畅很多。
         */
        const sphere1 = BABYLON.Mesh.CreateSphere("sphere", 4, 0.5, _scene);
        let redBalls = ['SCDS_W_F16_KTTF_FCU05_primitive0','SCDS_E_F10_KTTF_FCU02_primitive0']
        let index = mesh.id.indexOf('_primitive')
        let key = index !== -1 ? mesh.id.slice(0, index) : mesh.id
        let color_index 
        if(redBalls.includes(mesh.id)){
          color_index = 3
        }else{
          color_index = this.getRandomNumber() -1
        }
        if(!device_status[key]){
          device_status[key] = color_index
        }
        sphere1.material = colors[color_index]
        //模拟 zlxt中LQB4 设备停机
        if (mesh.name.includes('LQB4')){
          device_status[key] = 2
          sphere1.material = colors[2]
        }
        sphere1.position.x = mesh.absolutePosition.x;
        sphere1.position.y = mesh.absolutePosition.y;
        // 偏移的几个小球
        let jyb = ['JYB1', 'JYB2', 'JYB3', 'JYB4', 'JYB5']
        let jps = ['ZSB1', 'ZSB2']
        if (this.$props.systemKey === "zlxt" && mesh.id.includes('SCDS_A_F5_ZLXT_CT')) {
          sphere1.position.z = mesh.absolutePosition.z - 20;
        } else if (this.$props.systemKey === "xfxt" && jyb.includes(mesh.id.split('_')[4])) {
          sphere1.position.z = mesh.absolutePosition.z - 21.5;
          sphere1.position.y = mesh.absolutePosition.y + 2;
          sphere1.position.x = mesh.absolutePosition.x + 1;
        } else if (this.$props.systemKey === "jps" && jps.includes(mesh.id.split('_')[4])) {
          sphere1.position.z = mesh.absolutePosition.z - 2
          sphere1.position.x = mesh.absolutePosition.x + 4
        } else {
          sphere1.position.z = mesh.absolutePosition.z;
        }
        sphere1.isPickable = false
        container.meshes.push(sphere1)
      }
    },
    //电梯系统的动画
    DTXTAnimation() {
      console.log("启动动画");
      let _sub_system_meshs = containers['dtxt'].meshes
      console.log("----sub_system:", _sub_system_meshs);
      let frameRate = 30;
      let speedRatio = 0.1;
      let from = 0;
      let to = 4 * frameRate;
      // let loop = true; //是否循环播放
      let time = 10; //随机选择电梯停止时间 ： 1-10
      let an = this.createDTAnimation();
      //让电梯系统的每个电梯进行不同的上下移动
      for (let i = 1; i < 13; i++) {
        if (i === 1) {
          setTimeout(() => {
            this.runDTAnimation(_sub_system_meshs[i], an, from, to, speedRatio, 1, time);
          }, 1000 * i);
        } else {
          setTimeout(() => {
            this.runDTAnimation(_sub_system_meshs[i], an, from, to, speedRatio, 1, time);
          }, 1000 * (5 + i * 5));
        }
      }
    },
    //创建电梯动画
    createDTAnimation() {
      //创建电梯系统单独mesh的动画
      let height = 60;
      let frameRate = 30;
      let animation = new BABYLON.Animation("animation", "position.z",
        frameRate, BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
      let keyFrames = [];
      keyFrames.push({
        frame: 0,
        value: 0
      })
      keyFrames.push({
        frame: frameRate,
        value: height
      });
      keyFrames.push({
        frame: 2 * frameRate,
        value: -(height - 20)
      });
      keyFrames.push({
        frame: 3 * frameRate,
        value: height
      });
      keyFrames.push({
        frame: 4 * frameRate,
        value: 0
      })
      animation.setKeys(keyFrames);
      return animation;
    },
    //循环运行电梯动画，递归函数
    runDTAnimation(meshes, an, from, to, speedRation, runCount, pauseDuration) {
      let count = 0;

      function runAnimation() {
        if (isDT) {
          console.log("进入递归函数")
          if (count < runCount) {
            _scene.beginDirectAnimation(meshes, [an], from, to, false, speedRation, () => {
              count++;
              pauseDuration = Math.floor(Math.random() * 100);
              runAnimation();
            })
          } else {
            // an.pause();
            setTimeout(() => {
              count = 0;
              runAnimation();
            }, pauseDuration * 1000);
          }
        }
      }

      runAnimation();
    },
    //爆炸效果
    explode() {
      _camera.radius = 500;
      newExplosion.explode(2);
      this.isExplode = true
    },
    //模型复原
    recover() {
      _camera.radius = 300;
      newExplosion.explode(0); //Explodes meshes away from center. Default 1.0.
      this.isExplode = false
    },
    setIntervalCP() {
      this.oldAlpha = _camera.alpha;
      // let autoRotateBehavior = _camera.autoRotationBehavior;
      // autoRotateBehavior.rotationSpeed = 30;
      // autoRotateBehavior.autoRotate = true;
      //相机自动旋转
      _scene.activeCamera.useAutoRotationBehavior = true;
      let auto = _camera.autoRotationBehavior;
      //调整相机旋转速度
      auto.idleRotationSpeed = 0.5;
      this.isRotate = true
    },
    //结束旋转
    clearIntervalCP() {
      _scene.activeCamera.useAutoRotationBehavior = false;
      this.isRotate = false
    },
    // 消防报警测试按钮
    fireAlarm(){
      if(this.system_type !== 'floor_system'){
        this.addRedBallInFrameWork()
      }else{
        console.log('this.$route.params.floor',this.$route.params.floor);
        this.currentSystem = 'xfxt'
        this.loadFloorMeshs(this.currentFloor)
      }
    },
    //给框架添加红色小球
    addRedBallInFrameWork() {
      console.log("进入框架");
      this.clearBall();
      this.isWarning = true
      //加载安防系统
      this.addRedBallInModel(containers[framework_key].meshes[0]);
      // 建筑透明材质
      let warningMaterial = new BABYLON.StandardMaterial("warningMaterial", _scene);
      warningMaterial.alpha = 0.15;
      warningMaterial.emissiveColor = new BABYLON.Color3(1, 1, 0);
      _xfbj_mesh = []
      let animation = this.createFlickerAnimation();
      containers[framework_key].meshes.forEach((item) => {
        if (item.name.includes('F28_XFXTBJ_W')) {
          item.isPickable = true
          _xfbj_mesh.push(item)
          item.material = warningMaterial
          console.log("item.name.includes('F28_XFXTBJ_W')");
          item.animations = [];
          item.animations.push(animation);
          // 动画开始
          _xfbj_animation = _scene.beginAnimation(item, 0, 20, true, 0.5);
          //注册鼠标点击事件
          item.actionManager = new BABYLON.ActionManager(_scene);
          item.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, (evt) => {
            router.push({
              name: "project-scds-subsystems",
              params: {
                project_id: 82,
                system_key: 'xfxt',
                floor: 'F28',
                isWarning: true,
              }
            });
            //地板显示侧边栏
            if (!this.$route.path.includes("project-detail")) {
              this.$emit('showSidebar', { isShow: true, evt: evt });
            } else {
              this.$emit('showSidebar', { isShow: false, evt: null });
            }
          }))
        }
      })
    },
    //给模型添加红色小球
    addRedBallInModel(model) {
      let newMesh = [];
      let i = 0;
      let animation = this.createFlickerAnimation();
      //框架模型
      // 创建红色小球
      let redBall = BABYLON.MeshBuilder.CreateSphere("redBall", { diameter: 1 }, _scene);
      redBall.material = new BABYLON.StandardMaterial("redMaterial", _scene);
      redBall.material.emissiveColor = new BABYLON.Color3(255, 0, 0);
      redBall.material.diffuseColor = new BABYLON.Color3(255, 0, 0); // 红色
      redBall.animations = [];
      redBall.animations.push(animation);
      // 动画开始
      _scene.beginAnimation(redBall, 0, 20, true, 0.5);
      // 设置小球位置
      redBall.name = "redBall" + i;
      redBall.actionManager = new BABYLON.ActionManager(_scene);
      //注册鼠标点击事件
      redBall.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, (evt) => {
        router.push({
          name: "project-scds-subsystems",
          params: {
            project_id: 82,
            system_key: 'xfxt',
            floor: 'F28',
            isWarning: true,
          }
        });
      }))
      //注册鼠标滑动事件
      redBall.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, (evt) => {
        const box = document.getElementById('TC_box');
        let name = 'redBall';
        if (box) {
          this.cardTitle = '北办公区烟感';
          this.cardId = null;
          this.dPar = dParams[name];
          // 调整偏移量
          let cardX = evt.pointerX;
          let cardY = evt.pointerY;
          box.style.display = 'block';
          // box.style.top = (cardY - 180 - 10) + 'px'
          // box.style.left = (cardX + 40 + 5) + 'px'
          box.style.top = (cardY - 180 - 20) + 'px'
          box.style.left = (cardX + 40) + 'px'
        } else {
          document.getElementById('TC_box').style.display = 'none';
        }
      }, null)
      )
      redBall.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, (evt) => {
        document.getElementById('TC_box').style.display = 'none';
      }))
      // redBall.position.copyFrom(meshes[Math.floor(Math.random() * length)].absolutePosition);
      // redBall.position.copyFrom(meshes.absolutePosition);
      redBall.position = new BABYLON.Vector3(26.3250675201416, 57.2500114440918, -12.18267822265625)
      _redBall_meshes.push(redBall);
      // 将小球添加到场景中
      redBall.parent = model; // 将小球设为模型的子物体，这样它会随着模型的变换而移动

    },
    //添加楼层的消防报警小球
    addRedBallInFloor(container) {
      this.clearBall();
      this.isWarning = true
      console.log('keyf28');
      let animation = this.createFlickerAnimation();
      //框架模型
      // 创建红色小球
      let redBall = BABYLON.MeshBuilder.CreateSphere("redBall", { diameter: 1 }, _scene);
      redBall.material = new BABYLON.StandardMaterial("redMaterial", _scene);
      redBall.material.emissiveColor = new BABYLON.Color3(1, 0, 0);
      redBall.material.diffuseColor = new BABYLON.Color3(1, 0, 0); // 红色
      redBall.animations = [];
      redBall.animations.push(animation);
      // 动画开始
      _scene.beginAnimation(redBall, 0, 20, true, 0.5);
      // 设置小球位置
      redBall.name = "redBall";
      redBall.position = new BABYLON.Vector3(26.3250675201416, 0, -12.18267822265625)
      _redBall_meshes.push(redBall);

      let warningMaterial = new BABYLON.StandardMaterial("warningMaterial", _scene);
      warningMaterial.alpha = 0.15;
      warningMaterial.emissiveColor = new BABYLON.Color3(1, 1, 0);

      container.meshes.forEach(m => {
        if (m.name.includes('F28_XFXTBJ_E')) {
          _xfbj_mesh.push(m)
          m.material = warningMaterial
          m.animations = [];
          m.animations.push(animation);
          // 动画开始
          _scene.beginAnimation(m, 0, 20, true, 0.5);
          m.isPickable = true
          m.actionManager = new BABYLON.ActionManager(_scene);
          m.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, (evt) => {
            //地板显示侧边栏
            if (!this.$route.path.includes("project-detail")) {
              this.$emit('showSidebar', { isShow: true, evt: evt });
            } else {
              this.$emit('showSidebar', { isShow: false, evt: null });
            }
          }))
        }
      })
      this.$route.params.isWarning = false
    },
    //解除消防报警
    clearBall() {
      this.isWarning = false
      // 建筑透明材质
      let transparentMat = new BABYLON.StandardMaterial("transparentMat", _scene);
      transparentMat.alpha = 0.15;
      transparentMat.emissiveColor = new BABYLON.Color3(0.149, 0.357, 0.588);
      if (_xfbj_animation) {
        _xfbj_animation.stop()
        _xfbj_animation = null
      }
      if (_xfbj_mesh) {
        _xfbj_mesh.map(item => {
          item.material = transparentMat
        })
        _xfbj_mesh = []
      }
      if (_redBall_meshes) {
        _redBall_meshes.forEach(item => {
          item.dispose();
        })
      }
      _redBall_meshes = [];

    },
    //照明开发切换
    lightSwitch(item) {
      item.status = !item.status
      let meshes = [];
      if (this.system_type === 'system') {
        meshes = containers[this.currentSystem].meshes;
      } else if (this.system_type === 'floor_system') {
        meshes = containers[this.currentFloorSystem].meshes;
      }
      //原始材质
      let oldMaterial = new BABYLON.StandardMaterial("oldMaterial", _scene);
      //创建照明材质
      let lightMaterial = new BABYLON.StandardMaterial("lightMaterial", _scene);
      lightMaterial.emissiveColor = new BABYLON.Color3(0, 255, 0);
      lightMaterial.diffuseColor = new BABYLON.Color3(0, 255, 0);
      meshes.forEach((mesh) => {
        if (mesh.name.includes(item.name) && mesh.getClassName() === 'InstancedMesh') {
          if (item.status) {
            mesh.sourceMesh.material = lightMaterial;
          } else {
            mesh.sourceMesh.material = oldMaterial;
          }
        }
      })
    },
    getRandomNumber() {
      // 定义各个数字出现的概率
      const probabilities = [0.99, 0.005, 0.005];

      // 生成一个0到1之间的随机数
      const randomValue = Math.random();

      // 根据随机数和概率计算出随机数字
      let cumulativeProb = 0;
      for (let i = 0; i < probabilities.length; i++) {
        cumulativeProb += probabilities[i];
        if (randomValue < cumulativeProb) {
          return i + 1;
        }
      }
      // 如果概率加起来不等于1,则返回默认值1
      return 1;
    },

    //环境监测模型放大，修改颜色，显示温度
    showHJJCDetail(model){
      console.log("进入环境监测方法");
      advancedTexture = GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI")
      guiContainer = [];
      let red_material = new BABYLON.StandardMaterial("red_Material", _scene);
      // 设置材质属性
      red_material.diffuseColor = new BABYLON.Color3(1, 0.5, 0.5); // 设置漫反射颜色
      red_material.specularColor = new BABYLON.Color3(1, 0.2, 0.2); // 设置高光颜色
      red_material.specularPower = 16; // 设置高光强度
      red_material.ambientColor = new BABYLON.Color3(1, 0.2, 0.2); // 设置环境光颜色
      red_material.emissiveColor = new BABYLON.Color3(1, 0, 0); // 设置自发光颜色

      let green_material = new BABYLON.StandardMaterial("green_Material", _scene);
      // 设置材质属性
      green_material.diffuseColor = new BABYLON.Color3(0, 1, 0.5); // 设置漫反射颜色
      green_material.specularColor = new BABYLON.Color3(0, 1, 0.2); // 设置高光颜色
      green_material.specularPower = 16; // 设置高光强度
      green_material.ambientColor = new BABYLON.Color3(0, 1, 0.2); // 设置环境光颜色
      green_material.emissiveColor = new BABYLON.Color3(0, 1, 0); // 设置自发光颜色

      let blue_material = new BABYLON.StandardMaterial("blue_Material", _scene);
      // 设置材质属性
      blue_material.diffuseColor = new BABYLON.Color3(0, 0, 1); // 设置漫反射颜色
      blue_material.specularColor = new BABYLON.Color3(0, 0, 1); // 设置高光颜色
      blue_material.specularPower = 16; // 设置高光强度
      blue_material.ambientColor = new BABYLON.Color3(0, 0, 1); // 设置环境光颜色
      blue_material.emissiveColor = new BABYLON.Color3(0, 0, 1); // 设置自发光颜色

      let newMeshes = [];
      // GUI

      model.forEach((item,index) => {
        if(index <= 200 && index > 0 && index % 2 === 0) {
          if (item.getClassName() === "InstancedMesh"){
            //复制instencedMesh为mesh
            let newMesh = item.sourceMesh.clone(item.name+ '_' + index,item.parent);
            newMesh.position = item.position.clone();
            if (item.rotationQuaternion){
              newMesh.rotationQuaternion = item.rotationQuaternion.clone();
            }
            newMesh.actionManager = item.actionManager;
            newMesh.scaling = item.scaling.clone();
            item.dispose();
            item = newMesh;
          }
          //生成随机温度
          let high = (Math.random() * (30 - 26) + 26).toFixed(2);
          let low = (Math.random() * (22 - 20) + 20).toFixed(2);
          let num = (Math.random() * (26 - 23) + 23).toFixed(2);
          if (index === 20 || index === 30 || index === 40){
            num = high;
          }else if (index === 44 || index === 64 || index === 84){
            num = low;
          }
          HjjcT[item.name] = num;
          let label = new GUI.TextBlock();
          advancedTexture.addControl(label);
          label.text = num
          label.fontSize = 10;
          label.linkWithMesh(item);
          label.linkOffsetY = -10;
          if (num < 22){
            item.material = blue_material;
            label.color = "rgba(37, 110, 188, 1)"
          }else if (num >= 23 && num <= 26){
            item.material = green_material;
            label.color = "rgba(10, 147, 25, 0.75)"
          }else {
            item.material = red_material
            label.color = "rgba(225, 53, 22, 0.93)"
          }
          guiContainer.push(label);
          item.scaling = new BABYLON.Vector3(15, 15, 15); // 将网格放大10倍
        }
        newMeshes.push(item);
      })
      containers['hjjc'].meshes = newMeshes;
    }
  },
  mounted() {
    this.initScene();
    console.log('route', this.$route);
    if (this.$route.path.endsWith('all')) {
      this.loadFramework();
    } else {
      if (!this.$route.params.isWarning) {
        this.loadSubsystemMeshs(this.$props.systemKey)
      }else{
        this.currentSystem = 'xfxt'
        this.loadFloorMeshs(this.$route.params.floor)
      }
    }
  }
};
</script>

<template>
  <div class="w-100 h-100" style="outline: none !important; border: none !important; position: relative;"
    @mousewheel.prevent="() => { }" @contextmenu.prevent.capture>
    <!--首页按钮-->
    <div class="position-absolute" style="top: 3rem; right: calc(25% + 3rem)"
      v-if="this.$route.path.endsWith('detail')">
      <b-button-group>
        <!-- <b-button variant="outline-primary" id="btn1" @click="explode">
          <b-icon icon="arrows-expand" />
          <b-tooltip target="btn1" placement="left">
            楼层分离
          </b-tooltip>
        </b-button>
        <b-button variant="outline-primary" id="btn2" @click="recover">
          <b-icon icon="arrow-repeat" />
          <b-tooltip target="btn2" placement="left">
            模型还原
          </b-tooltip>
        </b-button> -->
        <b-button variant="outline-primary" id="btn3" v-if="!isRotate" @click="setIntervalCP">
          <b-icon icon="arrow-clockwise" />
          <b-tooltip target="btn3" placement="top">
            开始旋转
          </b-tooltip>
        </b-button>
        <b-button variant="outline-primary" id="btn4" v-else @click="clearIntervalCP">
          <b-icon icon="x-lg" />
          <b-tooltip target="btn4" placement="top">
            结束旋转
          </b-tooltip>
        </b-button>
        <b-button variant="outline-primary" id="btn5" to="/82/scds/subsystems/all">
          <b-icon icon="arrow-up-right-square" />
          <b-tooltip target="btn5" placement="top">
            进入子系统
          </b-tooltip>
        </b-button>
        <b-button variant="outline-primary" id="btn6" v-if="!isWarning" @click="fireAlarm">
          <b-icon icon="emoji-expressionless-fill" />
          <b-tooltip target="btn6" placement="top">
            消防报警测试
          </b-tooltip>
        </b-button>
        <b-button variant="outline-primary" id="btn7" v-else @click="clearBall">
          <b-icon icon="droplet-fill" />
          <b-tooltip target="btn7" placement="top">
            消防报警解除
          </b-tooltip>
        </b-button>
      </b-button-group>
    </div>
    <!-- 子系统按钮 style="bottom: 5rem; left: calc(10% + 1rem)"-->
    <div class="position-absolute" style="top: 5rem; right: calc(15% + 1rem)" v-else>
      <b-button-group size="sm">
        <b-button variant="outline-primary" id="btn1" v-if="!isExplode" @click="explode">
          <b-icon icon="arrows-expand" />
          <b-tooltip target="btn1" placement="top">
            楼层分离
          </b-tooltip>
        </b-button>
        <b-button variant="outline-primary" id="btn2" v-else @click="recover">
          <b-icon icon="arrow-repeat" />
          <b-tooltip target="btn2" placement="top">
            模型还原
          </b-tooltip>
        </b-button>
        <b-button variant="outline-primary" id="btn3" v-if="!isRotate" @click="setIntervalCP">
          <b-icon icon="arrow-clockwise" />
          <b-tooltip target="btn3" placement="top">
            开始旋转
          </b-tooltip>
        </b-button>
        <b-button variant="outline-primary" id="btn4" v-else @click="clearIntervalCP">
          <b-icon icon="x-lg" />
          <b-tooltip target="btn4" placement="top">
            结束旋转
          </b-tooltip>
        </b-button>
        <!-- <b-button variant="outline-primary" id="btn5" @click="toSubSystem">
          <b-icon icon="arrow-up-right-square" />
          <b-tooltip target="btn5" placement="top">
            点击子系统
          </b-tooltip>
        </b-button>
        <b-button variant="outline-primary" id="btn6" @click="toSystem">
          <b-icon icon="arrow-up-right-square" />
          <b-tooltip target="btn6" placement="top">
            查看框架系统
          </b-tooltip>
        </b-button> -->
        <b-button variant="outline-primary" id="btn6" @click="fireAlarm"
          v-if="this.currentSystem === 'xfxt' && !isWarning">
          <b-icon icon="emoji-expressionless-fill" />
          <b-tooltip target="btn6" placement="top">
            消防报警测试
          </b-tooltip>
        </b-button>
        <b-button variant="outline-primary" id="btn7" @click="clearBall" v-if="this.currentSystem === 'xfxt' && isWarning">
          <b-icon icon="droplet-fill" />
          <b-tooltip target="btn7" placement="top">
            消防报警解除
          </b-tooltip>
        </b-button>
      </b-button-group>
    </div>
    <canvas id="babylonCanvas" class="w-100 h-100" style="outline: none !important; border: none !important; ">
    </canvas>
    <div class="c_box" id="TC_box">
      <!-- 模型信息弹窗 -->
      <div class="c_content">
        <div id="babylonCanvas_mesh-info-card" class="meshInfoCard">
          <b-container class="bv-example-row">
            <b-row align-h="between">
              <b-col cols="auto">
                <h4 style="color: whitesmoke">{{ cardTitle }}</h4>
              </b-col>
            </b-row>
            <b-row align-h="between">
              <b-col cols="auto">
                <h6 style="color: whitesmoke" v-if="cardId !== null">[ID#{{ cardId }}]</h6>
              </b-col>
            </b-row>
            <b-row align-h="center" v-if="this.dPar === undefined">
              暂无数据
            </b-row>
            <b-row align-h="between" v-for="(item, index) in dPar" :key="index">
              <b-col cols="auto">{{ item.param }}</b-col>
              <b-col cols="auto" v-if="item.param_key==='S' && device_status_dict && currentKey && cardMeshId">{{
                item.unit.split('||')[device_status_dict[currentKey][cardMeshId]]
              }}
              </b-col>
              <b-col cols="auto" v-else-if="item.param_key==='F' && device_status_dict && currentKey && cardMeshId">{{
                device_status_dict[currentKey][cardMeshId] == 3 ?  item.unit.split('||')[1] : item.unit.split('||')[0]
              }}
              </b-col>
              <b-col cols="auto" v-else-if="item.unit.includes('||')">{{
                item.unit.split('||')[Math.round(Math.random())]
              }}
              </b-col>
              <b-col cols="auto" v-else-if="item.range.length === 0">
                <!--                暂时显示小红球的弹窗-->
                {{ item.unit }}
              </b-col>
              <b-col cols="auto" v-else-if="item.range.length < 2">
                {{ item.range[0] + item.unit }}
              </b-col>
              <b-col cols="auto" v-else-if="item.range.length > 1">{{
                (Math.floor(Math.random() * (item.range[1] - item.range[0] + 1)) + item.range[0]) +
                item.unit
              }}
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </div>
    <!--  灯光右侧卡片开关  -->
    <div class="position-absolute" style="top: 8rem; right: calc(15% + 1rem)"
      v-if="this.systemKey === 'ggzm' || this.systemKey === 'yjzm'">
      <b-card class="mb-2">
        <h4 class="mb-1">
          大厦灯光开关
        </h4>
        <b-row no-gutters v-if="this.systemKey === 'ggzm'">
          <b-col v-for="(item, key) in this.lightData" :key="key" cols="6" style="padding-right: 5px">
            <b-form-checkbox :checked="item.status" @change="lightSwitch(item)" switch style="margin-right: 5px">{{
              item.name
            }}
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row no-gutters v-else>
          <b-col v-for="(item, key) in this.yjLightData" :key="key" cols="6">
            <b-form-checkbox :checked="item.status" @change="lightSwitch(item)" switch style="margin-right: 10px">{{
              item.name
            }}
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <!--颜色提示-->
    <div class="position-absolute" style="bottom: 10rem; right: calc(15% + 1rem);display: flex;background-color: #283046;padding: 0.3rem 1rem;border-radius: 15px;"
      v-if="systemKey!=='all' && !this.$route.path.endsWith('detail')">
        <div style="display: flex;align-items: center;padding-right: 1rem;">
          <div style="width: 10px;height: 10px;border-radius: 50%;background-color: rgb(0, 255, 0);margin-right: 0.2rem;"></div>
          运行
        </div>
        <div style="display: flex;align-items: center;padding-right: 1rem;">
          <div style="width: 10px;height: 10px;border-radius: 50%;background-color: rgb(255, 0, 0);margin-right: 0.2rem;"></div>
          故障
        </div>
        <div style="display: flex;align-items: center;padding-right: 1rem;">
          <div style="width: 10px;height: 10px;border-radius: 50%;background-color: rgb(255, 185, 0); margin-right: 0.2rem;"></div>
          离线
        </div>
        <div style="display: flex;align-items: center;">
          <div style="width: 10px;height: 10px;border-radius: 50%;background-color: rgb(128, 128, 128);margin-right: 0.2rem;"></div>
          停机
        </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.meshInfoCard {
  color: whitesmoke;
  width: 250px;
  padding: 0.2rem 0.1rem;
  border-radius: 4px;
  backdrop-filter: blur(1px);
}

.c_box {
  display: none;
  background: rgba(135, 206, 250, 0.5);
  border-radius: 0.5rem;
  position: absolute;
  z-index: 9999;
  top: 0;
  left: 0;
  color: white;

  &::before {
    content: "";
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: rgb(79, 177, 230);
    position: absolute;
    opacity: 0;
    left: -44.8px;
    top: 319.2px;
    animation: color 1s infinite linear;
  }

  &::after {
    content: "";
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: rgb(79, 177, 230);
    position: absolute;
    left: -44.4px;
    top: 187px;
  }

  /*animation: rota 4s infinite ease;*/
}

.c_content {
  position: relative;
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    position: absolute;
    /*left: -14%;*/
    /*top: 25%;*/
    left: -20px;
    top: -3px;
    content: "";
    width: 1px;
    height: 40px;
    transform: rotate(90deg);
    background: rgb(79, 177, 230);

  }

  &::before {
    position: absolute;
    /*left: -28%;*/
    /*top: 50%;*/
    left: -40px;
    top: 17px;
    content: "";
    width: 1px;
    height: 180px;
    background: rgb(79, 177, 230);
  }
}
</style>
